import { render, staticRenderFns } from "./TemplateSelectionGalleryPanel.vue?vue&type=template&id=2d033596&scoped=true"
import script from "./TemplateSelectionGalleryPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionGalleryPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionGalleryPanel.vue?vue&type=style&index=0&id=2d033596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d033596",
  null
  
)

export default component.exports